import type { GetStaticProps } from "next";
import { ContentPage } from "@/types/PropTypes";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import BaseHeader from "@/components/BaseHeader";

import languages from "@/constants/languages.json";
import { getContentByPath } from "@/api/contentApis";

const Privacy = ({ metaTitle, metaDescription, metaKeywords, content }: ContentPage) => {
  return (
    <div>
      <BaseHeader title={metaTitle} description={metaDescription} keywords={metaKeywords} />
      <PrivacyPolicy content={content} />
    </div>
  );
};

export async function getStaticPaths() {
  const paths = languages.map((lang: string) => ({
    params: { lang },
  }));

  return { paths, fallback: "blocking" };
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  try {
    const data = await getContentByPath("privacy-policy");
    return { props: { ...data } };
  } catch (error) {
    return { notFound: true };
  }
};

export default Privacy;
